import api from '@pray/shared/utils/api';

import { PurchaseCreditsTopUpRequest } from './types';

type PurchaseCreditsTopUpProps = {
  artistId: string;
  quantity: number;
  paymentToken: string;
};

export const purchaseCreditsTopUp = async ({ artistId, quantity, paymentToken }: PurchaseCreditsTopUpProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!quantity || quantity <= 0) throw Error('Quantity must be a positive number');
  if (!paymentToken) throw Error('Payment token is required');

  const url = `/web/studio/artists/${artistId}/credits-top-up`;

  const payload: PurchaseCreditsTopUpRequest = {
    quantity,
    payment_token: paymentToken,
  };

  const response = await api.executePostRequest<undefined>(url, payload);

  return response.data;
};
